<template>
  <b-container fluid>
    <b-row>
      <b-col class="d-none d-md-block">
        <div v-if="!isGameUnstarted" class="logo-container">
          <b-img :src="whenceLogo" alt="Whence" />
          <b-link href="#" @click="about" class="text-warning about-link">About</b-link>
        </div>
      </b-col>
      <b-col class="zoom-col">
        <div v-if="!isGameUnstarted" class="zoom-container top-control-borders">
          <b-button
            variant="secondary"
            :disabled="isLoading || isGuessedPhase"
            class="zoom-button"
            @click="zoomOut"
          >
            <span class="d-none d-lg-inline"><b-img :src="zoomIcon" class="zoom-icon" /></span>
            Zoom Out
          </b-button>
          <div class="progress-bar-container">
            <div class="progress-bar" :style="progressBarStyle"></div>
          </div>
        </div>
      </b-col>
      <b-col class="round-col">
        <div v-if="!isGameUnstarted" class="round-container top-control-borders">
          <b-row>
            <b-col>
              <div class="round-label">Points</div>
              <div class="round-number">{{totalPoints}}</div>
            </b-col>
            <b-col class="round-label">
              <div class="round-label">Round</div>
              <div class="round-number">{{rounds.length}} / {{roundsPerGame}}</div>
            </b-col>
            <b-col>
              <b-button v-if="isGuessingPhase" :disabled="isLoading" @click="skip" class="round-button">Skip</b-button>
              <b-button v-if="isGuessedPhase || isGameFinished" :disabled="isLoading" @click="next" class="round-button">
                <span v-if="rounds.length < roundsPerGame">Next</span>
                <span v-else>Finish</span>
              </b-button>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { BButton, BCol, BContainer, BImg, BLink, BRow } from 'bootstrap-vue'
import { GAME_PHASE, ROUND_PHASE } from '../../constants/whence.js'
import whenceLogo from '../../img/whence/whence-logo.png'
import zoomIcon from '../../img/whence/zoom-icon.png'
import { Round } from '../../libs/whence/round.js'

export default {
  props: {
    gamePhase: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    },
    rounds: {
      type: Array,
      required: true
    },
    roundsPerGame: {
      type: Number,
      required: true
    },
    roundPhase: {
      type: String,
      required: true
    },
    zoomLevel: {
      type: Number,
      required: true,
    },
    maxResultZoomLevel: {
      type: Number,
      required: true,
    }
  },
  data: function() {
    return {
      whenceLogo: whenceLogo,
      zoomIcon: zoomIcon
    };
  },
  computed: {
    isGameUnstarted() {
      return this.gamePhase == GAME_PHASE.unstarted;
    },
    isGameFinished() {
      return this.gamePhase == GAME_PHASE.finished;
    },
    isGuessedPhase() {
      return this.gamePhase == GAME_PHASE.started && this.roundPhase == ROUND_PHASE.guessed;
    },
    isGuessingPhase() {
      return this.gamePhase == GAME_PHASE.started && this.roundPhase == ROUND_PHASE.guessing;
    },
    progressBarStyle() {
      if (this.rounds.length == 0) {
        return '';
      }
      const currentRound = this.rounds[this.rounds.length - 1];
      const roundMax = currentRound.maxZoomLevel;
      const zoomLevel = (currentRound.finalZoomLevel || currentRound.isSkipped) ? currentRound.finalZoomLevel : this.zoomLevel;
      const zoomFraction = (roundMax - zoomLevel) / (roundMax - this.maxResultZoomLevel);
      return `width: ${Math.round(zoomFraction * 100)}%;`
    },
    totalPoints() {
      return Round.totalPoints(this.rounds);
    }
  },
  methods: {
    about() {
      this.$emit('about');
    },
    newGame() {
      this.$emit('new-game');
    },
    next() {
      this.$emit('next');
    },
    skip() {
      this.$emit('skip');
    },
    zoomOut() {
      this.$emit('zoom-out');
    }
  },
  components: {
    'b-button': BButton,
    'b-col': BCol,
    'b-container': BContainer,
    'b-img': BImg,
    'b-link': BLink,
    'b-row': BRow
  }
}
</script>

<style scoped>
.zoom-col {
  text-align: center;
}
.top-control-borders {
  border-left: 2px white solid;
  border-bottom: 2px white solid;
  border-right: 2px white solid;
  background: #314659;
  border-radius: 4px;
  position: relative;
  top: -3px;
}
.zoom-container {
  display: inline-block;
  padding: 12px;
}
.zoom-button {
  color: #fdcd25;
  font-weight: bold;
}
.round-col {
  text-align: right;
}
.round-container {
  display: inline-block;
  padding: 12px;
  color: white;
}
.round-number {
  font-weight: bold;
  color: #fdcd25;
  white-space: nowrap;
}
.round-button {
  font-weight: bold;
  color: #fdcd25;
}
.progress-bar-container {
  margin-top: 0.7rem;
  width: 100%;
  background-color: #b0e2fb;
}
.progress-bar {
  background-color: green;
  height: 14px;
}
.zoom-icon {
  height: 1.4rem;
  margin-bottom: 0.2rem;
  margin-right: 0.3rem;
}
.logo-container {
  position: relative;
  display: inline-block;
}
.about-link {
  position: absolute;
  display: inline-block;
  top: 0;
  left: 0;
  width: 100%;
  text-align: right;
  padding-right: 18px;
  padding-top: 4px;
}

@media all and (min-width: 768px) {
  .zoom-button {
    font-size: 1.5rem;
  }
  .round-label {
    font-size: 1.4rem;
  }
  .round-number {
    font-size: 1.4rem;
  }
}
</style>
